import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 max-h-full overflow-auto base-scrollbar" }
const _hoisted_2 = { class: "modal-body" }

import { ref, watch } from 'vue';
import CloseModalIcon from "./CloseModalIcon.vue";
import {
  Dialog,
  TransitionRoot,
  TransitionChild,
  DialogPanel,
} from '@headlessui/vue';
import { toRefs } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ImageModal',
  props: {
    dialogPannelClasses: { default: '' },
    modalOuterContainerClasses: { default: '' },
    modalButtonClasses: { default: '' },
    defaultStateOfModal: { type: Boolean, default: false },
    isActiveCTA: { type: Boolean, default: true }
  },
  emits: ['modalClosed', 'modalButtonClicked'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const { dialogPannelClasses, defaultStateOfModal, isActiveCTA } = toRefs(props);

const emits = __emit;

const isOpen = ref(defaultStateOfModal.value);
const openModal = () => {
  if (isActiveCTA.value) {
    isOpen.value = true;
  }
  emits('modalButtonClicked');
};
const closeModal = () => {
  isOpen.value = false;
  emits('modalClosed');
};

watch(defaultStateOfModal, (value) => {
  isOpen.value = value;
});
__expose({
  closeModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      appear: "",
      show: isOpen.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-[101]",
          onClose: closeModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "modal-overlay" }, null, -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([
                'modal-dialog',
                _unref(dialogPannelClasses),
              ])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'modal-content',
                  _ctx.modalOuterContainerClasses,
                ])
                      }, [
                        _createVNode(CloseModalIcon, {
                          class: "modal-close-icon",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
                        }),
                        _createElementVNode("div", _hoisted_2, [
                          _renderSlot(_ctx.$slots, "modalContent")
                        ])
                      ], 2)
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]),
    (!_unref(defaultStateOfModal))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['w-full h-full modal-btn', _ctx.modalButtonClasses]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openModal()), ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "modalButton")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})